module.exports = __webpack_public_path__ + "img/reismithintergrund.a6a5ad66.jpg";